import React, { useContext } from 'react';
import classnames from 'classnames';
import { URLS, Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { ThemeContext } from '@wix/da-react-context/pkg/ThemeContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useCurrentPromo } from '../../../../utils/hooks/useCurrentPromo';
import SaleBanner from '../../../../banners/SaleBanner';
import MenuList from '@wix/da-ds/pkg/Dropdown/MenuList';
import AISuppressionSettingItem from '../../../_partials/AISuppressionSettingItem/AISuppressionSettingItem';
import { getMatureToggle, getThemeToggle } from './menuItemHelpers';
import UserMenuAvatar from './UserMenuAvatar';
import userMenuStyles from './UserMenu.scss';
const LoggedOutUserMenu = ({ isUserMenuOpened, onToggleUserMenu, toggleMature, toggleTheme, disableThemeSwitcher })=>{
    const { t } = useTranslation();
    const isHideAiSettingFlagEnabled = useFlag('hide_ai_setting');
    const currentPromo = useCurrentPromo('self');
    const theme = useContext(ThemeContext);
    const matureContent = useContext(MatureContext);
    const tabIndex = isUserMenuOpened ? 0 : -1;
    const items = [
        {
            className: userMenuStyles['top-group'],
            items: [
                {
                    label: /*#__PURE__*/ React.createElement("div", {
                        className: userMenuStyles['two-side-label']
                    }, /*#__PURE__*/ React.createElement("span", {
                        className: userMenuStyles['anon-hello']
                    }, t('siteHeaderMobile.userMenu.hello')), /*#__PURE__*/ React.createElement(UserMenuAvatar, {
                        onToggleUserMenu: onToggleUserMenu,
                        isUserMenuOpened: isUserMenuOpened,
                        tabIndex: tabIndex
                    }))
                }
            ]
        },
        {
            className: userMenuStyles['group'],
            items: [
                {
                    label: t('siteHeaderMobile.userMenu.signIn'),
                    link: Url.loginLink(),
                    biData: BiData({
                        evid: 702,
                        link_url: Url.loginLink(),
                        menu_item: 'login',
                        menu_name: 'profile'
                    }),
                    tabIndex
                },
                {
                    label: t('siteHeaderMobile.userMenu.join'),
                    link: Url.joinLink(),
                    biData: BiData({
                        evid: 240,
                        referral_info: ReferralType.HEADER
                    }),
                    tabIndex
                },
                {
                    label: /*#__PURE__*/ React.createElement("div", {
                        className: classnames(userMenuStyles['two-side-label'], userMenuStyles['buy-core-label'])
                    }, /*#__PURE__*/ React.createElement("span", null, t('siteHeaderMobile.userMenu.buyCoreMembership')), /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(CoreSymbol, {
                        corePackage: "core_access",
                        className: userMenuStyles['core-icon'],
                        size: IconSize.SMALL
                    }))),
                    link: Url.coreMembershipLink(),
                    biData: BiData({
                        evid: 702,
                        link_url: Url.coreMembershipLink(),
                        menu_item: 'core_membership',
                        menu_name: 'profile'
                    }),
                    tabIndex
                },
                currentPromo && {
                    label: null,
                    complexLabel: /*#__PURE__*/ React.createElement(SaleBanner, {
                        className: userMenuStyles['sale-banner'],
                        isNarrow: true,
                        endDate: currentPromo.endDate,
                        discountValuePercent: currentPromo.discountValuePercent,
                        referralType: ReferralType.PROMOTION_BANNER_USERMENU
                    })
                },
                !disableThemeSwitcher && getThemeToggle(theme, toggleTheme, t),
                getMatureToggle(!!matureContent, toggleMature, t),
                !isHideAiSettingFlagEnabled && {
                    label: /*#__PURE__*/ React.createElement(AISuppressionSettingItem, null)
                }
            ]
        },
        {
            className: userMenuStyles['group'],
            items: [
                {
                    label: t('siteHeader.userMenu.helpAndFAQ'),
                    link: URLS.HELP,
                    biData: BiData({
                        evid: 702,
                        link_url: URLS.HELP,
                        menu_item: 'help',
                        menu_name: 'profile'
                    }),
                    tabIndex
                },
                {
                    label: t('siteHeader.userMenu.termsOfService'),
                    link: Url.buildFromPath(URLS.TOS),
                    biData: BiData({
                        evid: 702,
                        link_url: Url.buildFromPath(URLS.TOS),
                        menu_item: 'tos',
                        menu_name: 'profile'
                    }),
                    tabIndex
                },
                {
                    label: t('siteHeader.userMenu.privacyPolicy'),
                    link: Url.buildFromPath(URLS.PRIVACY),
                    biData: BiData({
                        evid: 702,
                        link_url: Url.buildFromPath(URLS.PRIVACY),
                        menu_item: 'privacy_policy',
                        menu_name: 'profile'
                    }),
                    tabIndex
                }
            ]
        }
    ];
    return /*#__PURE__*/ React.createElement(MenuList, {
        renderOnSSR: true,
        id: "site-header-user-menu",
        className: classnames(userMenuStyles['user-menu']),
        itemsFillContainerWidth: true,
        items: items
    });
};
LoggedOutUserMenu.displayName = 'LoggedOutUserMenu';
export default LoggedOutUserMenu;
